import React from 'react';
import logo from '../../assets/imgs/logo2.png';
import './Header.css';
import MenuInterior from '../menuInterior/MenuInterior';
import { Link } from 'react-router-dom';

export default class Header extends React.Component{
    logout(e){
        e.preventDefault();
        localStorage.removeItem('token');
        window.location.reload();
    }

    render(){
        return(
            <nav className="navbar is-alpha is-fixed-top is-shadow" id="top">
                <div className="navbar-brand">
                    <Link className='navbar-item' to={'/Inicio'}>
                        <img src={logo} alt="Logo" />
                    </Link>
                    <div id="navbarBurger" className="navbar-burger burger" data-target="navMenu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="navbar-end">
                    <div className="navbar-item">
                        <label onClick={(e) => this.logout(e)}>
                            Cerrar Sesión
                        </label>
                    </div>
                </div>
            </nav>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/header/Header.js